import { useForm } from "react-hook-form";
import VendorAction from "../stores/actions/VendorAction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
type FormData = {
  id: number;
  company_name: string;
  name: string;
  mobile: any;
  email: string;
  country: string;
  state: string;
  district: string;
  pincode: any;
  address: string;
  gst_no: string;
};

function AddVendorModel({
  setCatModal,
  catModal,
  getVendorList,
  type,
  getVenData,
}: any) {
  const handleClose = () => setCatModal(false);
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  useEffect(() => {
    if (type === "update" && getVenData) {
      setValue("id", getVenData.id);
      setValue("company_name", getVenData.company_name);
      setValue("name", getVenData.name);
      setValue("mobile", getVenData.mobile);
      setValue("email", getVenData.email);
      setValue("country", getVenData.country);
      setValue("state", getVenData.state);
      setValue("district", getVenData.district);
      setValue("pincode", getVenData.pincode);
      setValue("gst_no", getVenData.gst_no);
      setValue("address", getVenData.address);
    } else {
      setValue("company_name", "");
      setValue("name", "");
      setValue("mobile", "");
      setValue("email", "");
      setValue("country", "");
      setValue("state", "");
      setValue("district", "");
      setValue("pincode", "");
      setValue("gst_no", "");
      setValue("address", "");
    }
  }, [type, getVenData, catModal]);

  const formHandleSubmit = async (data: any) => {
    setLoading(true);
    try {
      if (type === "add") {
        var VendorData = await dispatch(
          VendorAction.addVendor({
            company_name: data.company_name,
            name: data.name,
            mobile: data.mobile,
            email: data.email,
            country: data.country,
            state: data.state,
            district: data.district,
            pincode: data.pincode,
            address: data.address,
            gst_no: data.gst_no,
          }),
        );
      } else {
        var VendorData = await dispatch(
          VendorAction.updateVendor({
            id: data.id,
            company_name: data.company_name,
            name: data.name,
            mobile: data.mobile,
            email: data.email,
            country: data.country,
            state: data.state,
            district: data.district,
            pincode: data.pincode,
            address: data.address,
            gst_no: data.gst_no,
          }),
        );
      }

      if (VendorData.status === false) {
        toast.error(VendorData.msg);
        setLoading(false);
      } else {
        setLoading(false);
        reset();
        handleClose();
        getVendorList();
        toast.success(VendorData.msg);
      }
    } catch (error) {
      handleClose();
      setLoading(false);
    }
  };

  return (
    <div className="modal" style={{ display: catModal ? "block" : "none" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form
            className="needs-validation"
            onSubmit={handleSubmit(formHandleSubmit)}
            encType="multipart/form-data"
          >
            <div className="modal-header">
              <h5 className="modal-title">
                {type === "add" ? "Add new" : "Update"} Vendor
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-validation">
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-name"
                      placeholder="Enter Company Name"
                      {...register("company_name")}
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-name"
                      placeholder="Enter Name"
                      {...register("name")}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Mobile No.</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-sku"
                      placeholder="Enter Mobile No."
                      {...register("mobile")}
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Email Id</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      placeholder="Enter Email Id"
                      {...register("email")}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">GST No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      placeholder="Enter GST No."
                      {...register("gst_no")}
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Country</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      {...register("country")}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      {...register("state")}
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">District</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      placeholder="Enter District"
                      {...register("district")}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ecommerce-product-barcode"
                      placeholder="Enter Pincode"
                      {...register("pincode")}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      {...register("address")}
                      placeholder="Enter Address"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
                disabled={loading}
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary px-4"
              >
                {loading ? <i className={"fa fa-spinner fa-spin"}></i> : null}
                &nbsp; {type == "add" ? "Save" : "Update"} Vendor
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddVendorModel;
